export default __webpack_public_path__ + "static/media/le-amanah.d92c4578.png";